(function dayjsSetup() {
  dayjs.locale(dayjs_locale_es);
  dayjs.extend(dayjs_plugin_relativeTime);
})();

(function axiosSetup() {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 403) {
        domestiko.logout({ expired: true });
      }
      return Promise.reject(error);
    },
  );
})();

Vue.use(VueRouter);
Vue.filter('relativeTime', function (value, now) {
  if (!now) {
    now = new Date().toISOString();
  }
  const $now = dayjs(now);
  const $value = dayjs(value);
  return ($now > $value ? 'hace ' : 'dentro de ') + $now.from($value, true);
});

Vue.filter('capitalize', function (value) {
  return value[0].toUpperCase() + value.substring(1);
});

function range(start, end) {
  return [...Array(end - start + 1).keys()].map((d) => d + start);
}
